import { Button } from './ui/button';

type PollCheckItem = {
    original: string;
    converted: string;
    is_rewritten: boolean;
    reason: string;
    advice: string;
};

interface PollReviewModalProps {
    isOpen: boolean;
    onClose: () => void;
    onAccept: () => void;
    onSelfEdit: () => void;
    data: {
        question: PollCheckItem;
        options: PollCheckItem[];
    } | null;
}

export function PollReviewModal({ isOpen, onClose, onAccept, onSelfEdit, data }: PollReviewModalProps) {
    if (!isOpen || !data) return null;

    const renderItem = (label: string, item: PollCheckItem) => (
        <div className="bg-white rounded-md border border-[#800020]/10 p-3 space-y-2">
            <div className="text-xs font-bold text-[#800020] uppercase tracking-wider">{label}</div>
            <div className="text-xs text-gray-500">元の文章</div>
            <div className="text-gray-700 whitespace-pre-wrap">{item.original}</div>
            <div className="text-xs text-gray-500 mt-2">修正案</div>
            <div className="text-gray-900 font-medium whitespace-pre-wrap">{item.converted}</div>
            {(item.reason || item.advice) && (
                <div className="text-xs text-gray-600 space-y-1">
                    {item.reason && (
                        <div>
                            <span className="font-bold text-[#800020] mr-1">検閲理由:</span>
                            {item.reason}
                        </div>
                    )}
                    {item.advice && (
                        <div>
                            <span className="font-bold text-[#800020] mr-1">アドバイス:</span>
                            {item.advice}
                        </div>
                    )}
                </div>
            )}
        </div>
    );

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
            <div className="bg-white rounded-lg shadow-xl max-w-3xl w-full overflow-hidden animate-in fade-in zoom-in-95 duration-200 max-h-[85vh] flex flex-col">
                <div className="bg-[#800020] px-6 py-4 flex justify-between items-center">
                    <h3 className="text-lg font-bold text-white tracking-widest">POLL REVIEW</h3>
                    <button onClick={onClose} className="text-white/80 hover:text-white text-2xl">&times;</button>
                </div>

                <div className="p-6 space-y-4 overflow-y-auto">
                    <div className="text-sm text-gray-700">
                        検閲により修正が提案されました。内容をご確認のうえ、承認するかご自身で書き直してください。
                    </div>
                    {renderItem('質問', data.question)}
                    {data.options.map((option, index) => (
                        <div key={`${option.original}-${index}`}>
                            {renderItem(`選択肢 ${index + 1}`, option)}
                        </div>
                    ))}
                </div>

                <div className="px-6 pb-6 pt-2 flex justify-center gap-3">
                    <Button
                        onClick={onAccept}
                        className="bg-[#800020] hover:bg-[#600018] text-white px-8"
                    >
                        承認して作成
                    </Button>
                    <Button
                        variant="outline"
                        onClick={onSelfEdit}
                        className="px-6 text-gray-600"
                    >
                        自分で書き直す
                    </Button>
                </div>
            </div>
        </div>
    );
}
